var isPage = "";
let $body;
var common = {
	isLoadMore: false,
	init: ()=>{
		$body = $("body");
		common.start();
		window.addEventListener('popstate', function (e) {
			fw.checkURL();
		});
		/*
		setInterval(function(){
			$("a#btn_copy_link").html($(document).scrollTop());
		},100);
		*/
	},
	start: function(){
		var resizeFlag;
		var resizeTimer = null;
		var $body = $("body");
		common.nav();
		common.resize();
		fw.checkURL();
		
		/* window resize ----------------------------- */
		var resizeCallback = function() {
			common.resize();
			resizeTimer = null;
		};

		$(window).off("resize").on("resize",function(){
			if(resizeTimer) {
				clearTimeout(resizeTimer);
			}
			resizeTimer = setTimeout(resizeCallback, 300);
		});
	},
	nav: ()=>{
		//グロナビ、ページ切り替え
		$("#glbnav a").off().on("click", function(e){
			e.preventDefault();
			let $this = $(this);
			let url = $this.attr("href");
			let label = $(this).attr("data-event");
			
			if( !$this.hasClass("select_lang")){
				if( !$html.classList.contains("show_lang") ){
					common.sendEvent( label, location.pathname + location.search );
					$("#glbnav a").removeClass("active");
					$this.addClass("active");
					fw.changeURL(url);
				}
			}else{
				if( $this.hasClass("select_lang") ){
					if( !$html.classList.contains("lang") ){
						$this.addClass("active");
						$html.classList.add("lang");
						common.sendEvent( label, location.pathname + location.search );
						setTimeout(function(){
							$html.classList.add("show_lang");
						},50);
					}else{
						closeLang();
					}
				}
			}
		});
		$("#bg_lang").off().on("click", function(){
			closeLang();
		});
		function closeLang(){
			$("#glbnav a.select_lang").removeClass("active");
			$html.classList.remove("show_lang");
			setTimeout(function(){
				$html.classList.remove("lang");
			},400);
		}
		$("#nav_lang li a").off().on("click", function(){
			let lang = $(this).attr("data-lang");
			let currentURL = location.pathname;
			let urlArry = currentURL.split("/");
			let url = "";
			let param = location.search.substring(1);
			for(var i = 0; i < urlArry.length; i++){
				if(i === 2){
					url += lang + "/";
				}else{
					if(i === urlArry.length-1){
						url += urlArry[i];
					}else{
						url += urlArry[i] + "/";
					}
				}
			}
			if(param != ""){
				url = url + "?" + param;
			}else{
				url = url;
			}
			
			location.href = url;
			//console.log(urlArry, url, lang);
		});

		//SPOT DECKSの検索切り替えナビ
		$("#nav_search li a").off().on("click", function(e){
			let cat = $(this).attr("data-name");
			let url = "/tokyo/" + page.lang + "/" + page.folder + "?search=" + cat;
			window.scrollTo(0, 0);
			fw.changeURL(url);
		});

		//category
		$(".get_list li a").off().on("click", function(e){
			e.preventDefault();
			let $this = $(this);
			let url = $this.attr("href");
			let path = url.replace( location.protocol + "//" + window.location.host, "");
			common.sendPageView("search_" + page.folder + ":" + $("#nav_search li a.active").attr("data-name"), path);	//ga
			fw.changeURL(url);
		});
		$(".get_tag li a").off().on("click", function(e){
			e.preventDefault();
			let $this = $(this);
			let url = $this.attr("href");
			let path = url.replace( location.protocol + "//" + window.location.host, "");
			common.sendPageView("search_" + page.folder + ":" + $("#nav_search li a.active").attr("data-name"), path);	//ga
			fw.changeURL(url);
		});
		//スポット詳細
		$(".list_link_spot li a").off().on("click", function(e){
			e.preventDefault();
			let $this 	= $(this);
			let url 	= $this.attr("href");
			let urlArry = url.split("/");
			let currentURL = location.pathname;
			let currentArry = currentURL.split("/");

			common.sendEvent( "search_" + page.type + ":" + currentArry[currentArry.length-1], urlArry[urlArry.length-1] );
			//return false
			fw.changeURL(url);
		});
		//DECK詳細 > スポット
		$(".deck_to_spot").off().on("click", function(e){
			e.preventDefault();
			let url = $(this).attr("href");
			let urlArry = url.split("/");
			common.sendEvent( "show_more:" + urlArry[urlArry.length-1], location.pathname + location.search );
			common.loadDeckToSpot(url);
		});
		//spot > deck
		$(".spot_to_deck").off().on("click", function(e){
			e.preventDefault();
			let url = $(this).attr("href");
			let urlArry = url.split("/");
			let path = url.replace( location.protocol + "//" + window.location.host, "");
			common.sendEvent( "related_deck:" + urlArry[urlArry.length-1] , path );
			fw.changeURL(url);
		});
		$("#related_deck a.btn_link_map").off().on("click", function(e){
			e.preventDefault();
			let url = $(this).attr("href");
			let urlArry = url.split("/");
			let path = url.replace( location.protocol + "//" + window.location.host, "");
			common.sendEvent( "related_deck_mapview:" + urlArry[urlArry.length-1] , path );
			fw.changeURL(url);
		});
		$("a.link_to_spot").off().on("click", function(e){
			e.preventDefault();
			let $this 		= $(this);
			let url 		= $this.attr("href");
			let urlArry 	= url.split("/");
			let eventName 	= $(this).attr("data-event-name");
			if(eventName === "recommend"){
				let urlArry = url.split("/");
				common.sendEvent( "recommend:" + urlArry[urlArry.length-1], location.pathname);
			}else if(eventName === "recommend_from_spot"){
				let urlArry = url.split("/");
				common.sendEvent( "recommend:" + urlArry[urlArry.length-1], location.pathname + location.search);
			}else if(eventName === "genre"){
				let currentURL = location.pathname;
				let currentArry = currentURL.split("/");
				common.sendEvent( "search_spot:genre:" + currentArry[currentArry.length-1], urlArry[urlArry.length-1]);
			}
			fw.changeURL(url);
		});
		//cardview
		$(".to_deck").off().on("click", function(e){
			e.preventDefault();
			let $this = $(this);
			let url = $this.attr("href");
			let urlArry = url.split("/");
			let currentURL 	= location.pathname;
			let currentArry = currentURL.split("/");
			common.sendEvent( "search_" + page.folder + ":" + currentArry[currentArry.length-2] + ":" + currentArry[currentArry.length-1], urlArry[urlArry.length-1] );
			fw.changeURL(url);
		});
		$(".to_map").off().on("click", function(e){
			e.preventDefault();
			let $this = $(this);
			let url = $this.attr("href");
			fw.changeURL(url);
		});
		//map
		$("a.btn_map").off().on("click", function(e){
			e.preventDefault();
			let url 	= location.pathname + "?map";
			let spotURL = $("#deckslideshow .slideshow_txt li").eq( parseInt($(this).attr("data-num")) ).find("a.deck_to_spot").attr("href");
			let urlArry = spotURL.split("/");
			common.sendEvent( "deck_map:spot:" + urlArry[urlArry.length-1], location.pathname + "?map");
			
			fw.changeURL(url);
		});
		//URL copy
		$("a#btn_copy_link").off().on("click", function(){
			var copyTarget = $("input.share_url")[0];
			copyTarget.select();
			var range = document.createRange();
			range.selectNodeContents(copyTarget);
			var sel = window.getSelection();
			sel.removeAllRanges();
			sel.addRange(range);
			copyTarget.setSelectionRange(0, 999999);
			document.execCommand("copy");
			alert("copied URL");
		});
		//
		$("a#btn_back").off("click").on("click", function(){
			if( !$(this).hasClass("disable") ){
				history.back();
				//fw.checkURL();
			}
		});
		//about
		$("a.btn_about").off().on("click", function(e){
			e.preventDefault();
			let url = $(this).attr("href");
			fw.changeURL(url);
		});
		
		$("a.btn_internal").off().on("click", function(e){
			e.preventDefault();
			let url = $(this).attr("href");
			fw.changeURL(url);
		});
		$("#spot .tags li a").off().on("click", function(e){
			e.preventDefault();
			is_detail_to_sort = true;
			let url = $(this).attr("href");
			let path = url.replace( location.protocol + "//" + window.location.host, "");
			common.sendEvent( "click:tags:" + $(this).attr("data-type") + ":" + $(this).attr("data-slug") , path);
			fw.changeURL(url);
		});
		//topのdeck
		$("a.home_deck_link").off().on("click", function(e){
			e.preventDefault();
			let url = $(this).attr("href");
			fw.changeURL(url);
		});
		//archive 読み込み
		$("a.btn_more").off().on("click", function(e){
			e.preventDefault();
			loadPage.isLoadMore = true;
			archivePage.max = parseInt( $(this).parent().attr("data-max") );
			//console.log(archivePage.current, " / ", archivePage.max);
			archivePage.current++;
			if(archivePage.current >= archivePage.max){
				$(".wrap_more").remove();
			}
			$(this).parent(".wrap_more").attr("data-current", archivePage.current);
			let url = location.pathname + "?type=deck&page=" + archivePage.current;
			let urlArry = url.split("/");
			let path = url.replace( location.protocol + "//" + window.location.host, "");
			common.sendPageView( "search_" + page.folder + ":" + urlArry[urlArry.length-2], path);

			loadPage.loadMoreArchive(url);
			//fw.changeURL(url);
		});
		//console.log("common nav")
		//map > spot
		/*$("a.map_to_spot").off().on("click", function(e){
			e.preventDefault();
			let url = $(this).attr("href");
			
		});
		*/
		$("a.link_history").off().on("click", function(e){
			e.preventDefault();
			let url = $(this).attr("href");
			let urlArry = url.split("/");
			common.sendEvent( "history:" + urlArry[urlArry.length-1], location.pathname + location.search );
			location.href = url;
		});
		$(".link_to_map a").off().on("click", function(){
			common.sendEvent( "spot_map", location.pathname + location.search );
		});
	},
	resize: ()=>{
		var winW = window.innerWidth;
		var winH = window.innerHeight;
		var $body = $("body");

		$("#glbnav").css("width", winW + "px")
		//カードビューだったらカードの配置をリサイズ
		if( $("#deck_cardview").hasClass("show") ){
			let posX = 0;
			$("#list_cardview li").each(function(i){
				posX = window.innerWidth*i;
				$(this).css({
					"z-index": $("ul#list_cardview li").length - i
				});
			});
		}
		homeSlide.resize();
		setTimeout(function(){
			if($body.hasClass("resize")){
				$body.removeClass("resize");
			}
		},300);
	},
	makeIO: function(){
		for(var i = 0; i < ioArry.length; i++){
			let option = {
				root 		: null,
				rootMargin 	: ioArry[i].margin,
				threshold 	: ioArry[i].threshold
			}
			let element = $(ioArry[i].target)
			const io = new IntersectionObserver(ioArry[i].change, option);
			$.each(element, function(index, el){
				io.observe(el);
			});
		}
	},
	scrollToPosition: (posY, duration) =>{
		//console.trace("scroll")
		var $page 	= $("html,body"),
			ease 	= "easeInOutCubic";
		$page.animate({
			scrollTop : posY + "px"
		},{
			"duration" 	: duration,
			"easing" 	: ease
		});
	},
	scrl: () =>{
		var topD = $(document).scrollTop(),
			btmD = topD + $(window).height();

	},
	showLoading: function(){
		var defer = $.Deferred();
		var $loading;
		//observer.disconnect();
		if(page.folder === "spot"){
			$("#spot").addClass("disable");
		}else if(page.folder === "deck"){
			$("#deck_cardview").addClass("disable");
		}
		setTimeout(function(){
			common.scrollToPosition(0, 100);
			setTimeout(function(){
				defer.resolve();
			},100);
		},400);
		return defer.promise();
	},
	closeLoading: function(){
		var defer = $.Deferred();
		var $loading;
		//observer.disconnect();
		fw.beforeCloseLoading();
		if(page.folder === "spot"){
			$("#spot").removeClass("disable");
			defer.resolve();
		}else if(page.folder === "deck"){
			$("#deck_cardview").removeClass("disable");
			defer.resolve();
		}
		return defer.promise();
	},
	loadDeckToSpot: function(url){
		$("#deck_cardview").addClass("disable");
		//spotへ移動するかもしれないので
		$("#spot").addClass("disable");
		setTimeout(function(){
			fw.changeURL(url);
		}, 400);
	},
	sendPageView: function(action, label){
		let pageview = "%cpage:action:" + action + ", label: " + label;
		console.log(pageview, 'color: #068f9b');
		//ga('send', 'pageview', label);
		var pageName = "";
		
		dataLayer.push({
			event: 'pageview',
			eventCategory: page.lang,
			eventAction: action,
			eventLabel: label
		});
	},
	sendEvent: function( action, label){
		let clickEvent = "%cclick:action:" + action + ", label: " + label;
		console.log(clickEvent, 'color: #9ce924');
		//ga('send', 'event', category, action, label);
		
		dataLayer.push({
			event: 'click',
			eventCategory: page.lang,
			eventAction: "click:" + action,
			eventLabel: label
		});
	},
	sendMapEvent: function(url){
		console.log(url)
		let urlArry = url.split("/");
		common.sendEvent("deck_map:spot:" + urlArry[urlArry.length-1], location.pathname + location.search);
		$("body").removeClass("scroll_deck");
		$("body").removeClass("is_mapview");
		$("body").removeClass("is_cardview");
		fw.changeURL(url);
	}
}
document.addEventListener('DOMContentLoaded', function () {
	isPage = $("body").attr("id");
	common.init();
});